<template>
    <div class="div-bg">
        <!-- <img src="../assets/images/login_bg.png" -->
        <!-- style="border: 0;width: 100%;height: 100%;position: absolute;left: 0;top: 0;right: 0;bottom: 0;z-index: -999;"> -->
        <div style="" ref="refLoginDiv" :style="{marginTop:panelMarginTop+'px'}">
            <div style="text-align: center;">
                <img src="../../assets/images/heng_dian.png" alt="" style="width: 270px;height: 55px;">
            </div>
            <div style="display: flex;justify-content: center;align-items: center;margin-top: 1em;">
                <el-card style="width: 620px;">
                    <p style="font-weight: bolder;font-size: 24px;text-align: center;margin-top: 40px;">注册成功
                    </p>
                    <div style="text-align: center;">
                        <i class="el-icon-success" style="font-size: 80px;color: #5cb138;"></i>
                    </div>
                    <p style="text-align: center;color: #999999;">接下来您可以进行</p>
                    <div style="padding-left: 150px;padding-right: 150px;">
                        <el-row class="checkList">
                            <el-col :span="12" style="text-align: center;">
                                <img src="../../assets/images/register/shi_ming_ren_zheng.png" alt="" v-if="!isShiMing"
                                     @mouseenter="shiMingEnter()">
                                <img src="../../assets/images/register/shi_ming_ren_zheng_checked.png" alt=""
                                     v-if="isShiMing" @mouseleave="shiMingLeave()" @click="toShiMing()">
                                <p style="padding: 0;margin: 0;font-size: 12px;color: #999999;text-align: center;">实名认证
                                </p>
                            </el-col>
                            <el-col :span="12" style="text-align: center;">
                                <img src="../../assets/images/register/cheng_wei_lao_shi.png" alt="" v-if="!isTeacher"
                                     @mouseenter="teacherEnter()">
                                <img src="../../assets/images/register/cheng_wei_lao_shi_checked.png" alt=""
                                     v-if="isTeacher" @mouseleave="teacherLeave()" @click="toTeacher()">
                                <p style="padding: 0;margin: 0;font-size: 12px;color: #999999;text-align: center;">成为老师
                                </p>
                            </el-col>
                        </el-row>
                    </div>
                    <p style="font-size: 14px;text-align: center;margin-top: 40px;margin-bottom: 30px;">
                        {{ timeLimit }}秒后自动 <span style="color: #00a4e0;cursor: pointer;"
                                                  @click="toLogin()">返回登录页</span>
                    </p>
                </el-card>
            </div>
        </div>
        <hd-footer></hd-footer>
    </div>
</template>

<script>
import HdFooter from '../public/Footer.vue'

export default {
    name: 'Success',
    components: {
        HdFooter
    },
    created () {
        let that = this
        setTimeout(function () {
            that.timeDec()
        }, 1000)
    },
    mounted () {
        let that = this
        this.$nextTick(function () {
            that.setPanelPosition()
        })
    },
    data: function () {
        return {
            panelMarginTop: 0,
            form: {
                username: '',
                password: ''
            },
            rules: {},
            isShiMing: false,
            isTeacher: false,
            timeLimit: 5,
            goRealName: false,
            goTeacher: false
        }
    },
    methods: {
        setPanelPosition: function () {
            let h = this.$refs.refLoginDiv.offsetHeight
            this.panelMarginTop = this.getClientTop(h)
        },
        timeDec: function () {
            if (this.timeLimit > 0) {
                this.timeLimit--
            }
            if (this.timeLimit == 0) {
                //跳转
                if (!this.goRealName && !this.goTeacher) {
                    //未做任何选择
                    this.toLogin()
                }
            } else {
                let that = this
                setTimeout(function () {
                    that.timeDec()
                }, 1000)
            }
        },
        toLogin: function () {
            this.$router.push({
                path: '/'
            })
        },
        shiMingEnter: function () {
            this.isShiMing = true
        },
        shiMingLeave: function () {
            this.isShiMing = false
        },
        teacherEnter: function () {
            this.isTeacher = true
        },
        teacherLeave: function () {
            this.isTeacher = false
        },
        toShiMing: function () {
            this.goRealName = true
            this.$router.push({
                path: '/register-realname'
            })
        },
        toTeacher: function () {
            this.goTeacher = true
            this.$router.push({
                path: '/teacher-agreement'
            })
        }
    }
}
</script>

<style scoped="scoped">
.div-bg {
    background-image: url(../../assets/images/login_bg.png);
    border: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
}

.formItemDesc {
    font-size: 12px;
    padding: 0;
    margin: 0;
    line-height: 20px;
    text-align: left;
    color: #999999;
}

.go-login {
    color: #00a4e0;
    text-decoration: none;
}

.checkList img {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/register/Success.vue